(function adminMetadataDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminMetadataService', [
            'restUrlBuilder', function adminMetadataService(restUrlBuilder) {               
                this.getById = function getById(id) {
                    return restUrlBuilder.one('adminMetadata', id).get();
                };

                this.get = function get(name, label, organizationalUnitId) {
                    var params = { Name: name, Label: label, OrganizationalUnitId : organizationalUnitId };

                    return restUrlBuilder.all('adminMetadata')
                        .get({ params: params });
                };

                this.getNotInDocumentType = function (documentTypeId) {
                    var params = { NotInDocumentType: documentTypeId };
                    return restUrlBuilder.all('adminMetadata')
                        .get({ params: params });
                };

                this.getNotInContainerType = function (containerTypeId) {
                    var params = { NotInContainerType: containerTypeId };
                    return restUrlBuilder.all('adminMetadata')
                        .get({ params: params });
                };

                this.getTypeDatas = function getTypeDatas() {
                    return restUrlBuilder.all('TypeData').get();
                };

                this.create = function metadataCreate(metadata) {
                    if (metadata == null)
                        throw "Meta Data no puede ser null";

                    return restUrlBuilder.all('adminMetadata')
                      .post(metadata);
                };

                this.modify = function metadataModify(metadata) {
                    if (metadata == null)
                        throw "Meta Data no puede ser null";

                    return restUrlBuilder.all('adminMetadata').put(metadata);
                };

                this.addMetadataValues = function addMetadataValues(metadata) {
                    if (metadata == null)
                        throw "Meta Data no puede ser null";

                    return restUrlBuilder.all('adminMetadata/AddMetadataValues').put(metadata);
                };
            }
        ]);
})();